interface ValidationServiceMetadataInterface {
  attributeName: string;
  serviceName: string;
}

export const ValidationServiceMetadata: ValidationServiceMetadataInterface[] = [
  {
    attributeName: "validationDetailResultHattrick",
    serviceName: "Hattrick",
  },
  { attributeName: "validationDetailResultLVS", serviceName: "LVS" },
];
